import create, { SetState, StateCreator, StoreApi } from "zustand";

interface IHighIntensityProgramStore {
  clearStore: () => void;

  assignedProgramDetails: any;
  setAssignedProgramDetails: (x: any) => void;

  isHIPOpenDrawer: boolean;
  setIsHIPOpenDrawer: (x: boolean) => void;

  hipMemberList: any;
  setHipMemberList: (x: any) => void;

  hipFilters: any;
  setHipFilters: (x: any) => void;

  selectedHipMember: any;
  setSelectedHipMember: (x: any) => void;

  hipDashBoardPageSize: number;
  setHipDashBoardPageSize: (x: number) => void;

  hipDashBoardCurrentPage: number;
  setHipDashBoardCurrentPage: (x: number) => void;

  loggedInUserCategory: any;
  setLoggedInUserCategory: (x: any) => void;
}

let store: StateCreator<IHighIntensityProgramStore, [], [], IHighIntensityProgramStore> | StoreApi<IHighIntensityProgramStore> = (set: SetState<IHighIntensityProgramStore>) => ({
  assignedProgramDetails: [],
  setAssignedProgramDetails: (x) => {
    set(() => ({ assignedProgramDetails: x }));
  },

  isHIPOpenDrawer: false,
  setIsHIPOpenDrawer: (x) => {
    set(() => ({ isHIPOpenDrawer: x }));
  },

  hipMemberList: [],
  setHipMemberList: (x) => {
    set(() => ({ hipMemberList: x }));
  },

  selectedHipMember: undefined,
  setSelectedHipMember: (x) => {
    set(() => ({ selectedHipMember: x }));
  },

  hipDashBoardPageSize: 5,
  setHipDashBoardPageSize: (x) => {
    set(() => ({ hipDashBoardPageSize: x }));
  },

  hipDashBoardCurrentPage: 1,
  setHipDashBoardCurrentPage: (x) => {
    set(() => ({ hipDashBoardCurrentPage: x }));
  },

  loggedInUserCategory: undefined,
  setLoggedInUserCategory: (x) => {
    set(() => ({ loggedInUserCategory: x }));
  },

  hipFilters: {
    sortDataIndex: "assignment_date",
    sortOrder: "descend",
    searchText: "",
    searchDataIndex: "",
  },
  setHipFilters: (x) => {
    set(() => ({ hipFilters: x }));
  },
  
  clearStore: () => {
    set(() => ({ assignedProgramDetails: [] }));
    set(() => ({ isHIPOpenDrawer: false }));
    set(() => ({ hipMemberList: [] }));
    set(() => ({ selectedHipMember: undefined }));
    set(() => ({ hipDashBoardPageSize: 5 }));
    set(() => ({ hipDashBoardCurrentPage: 1 }));
    set(() => ({ loggedInUserCategory: undefined }));
    set(() => ({
      hipFilters: {
        sortDataIndex: "assignment_date",
        sortOrder: "descend",
        searchText: "",
        searchDataIndex: "",
      },
    }));
  },
});

export const useHighIntensityProgramStore = create(store);
